import React, { useEffect, useState } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../firebase";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { Card, CardContent } from "../components/ui/card";

const ContactSettings = () => {
 const [formData, setFormData] = useState({
  headOfficeAddress: "",
  branchOfficeAddress: "",

  headOfficeMap: "",
  branchOfficeMap: "",

  phone: "",
  whatsapp: "",
  email: "",
  businessHours: "",

  facebook: "",
  instagram: "",
});

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  // Load existing data
  useEffect(() => {
    const fetchData = async () => {
      const ref = doc(db, "siteSettings", "contactInfo");
      const snap = await getDoc(ref);

      if (snap.exists()) {
        const data = snap.data();
        setFormData({
        headOfficeAddress: data.addresses?.headOffice || "",
branchOfficeAddress: data.addresses?.branchOffice || "",

headOfficeMap: data.maps?.headOffice || "",
branchOfficeMap: data.maps?.branchOffice || "",
          phone: data.phone || "",
          whatsapp: data.whatsapp || "",
          email: data.email || "",
          businessHours: data.businessHours || "",
          facebook: data.social?.facebook || "",
          instagram: data.social?.instagram || "",
        });
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Show confirmation modal
  const handleSaveClick = () => setShowConfirm(true);

  // Save to Firestore
  const confirmSave = async () => {
    setShowConfirm(false);
    setSaving(true);
    try {
      await setDoc(
        doc(db, "siteSettings", "contactInfo"),
        {
          addresses: {
  headOffice: formData.headOfficeAddress,
  branchOffice: formData.branchOfficeAddress,
},

maps: {
  headOffice: formData.headOfficeMap,
  branchOffice: formData.branchOfficeMap,
},
          phone: formData.phone,
          whatsapp: formData.whatsapp,
          email: formData.email,
          businessHours: formData.businessHours,
          social: {
            facebook: formData.facebook,
            instagram: formData.instagram,
          },
        },
        { merge: true }
      );
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 2000);
    } catch (err) {
      console.error(err);
      alert("Something went wrong ❌");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen bg-bg-1 py-12">
      <div className="container-custom">
        <div className="mb-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-brand-dark mb-2">
            Contact Settings
          </h1>
          <p className="text-gray-600 text-lg md:text-xl max-w-3xl mx-auto">
            Update your office address, phone numbers, social links, and map
            location here. Any changes will reflect on the main website
            instantly.
          </p>
        </div>
        <Card className="card-hover">
          <CardContent className="p-6 md:p-8 space-y-6">
            {/* Address */}
            <div className="space-y-2">
             <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

  <div className="space-y-2">
    <Label>Head Office Address</Label>
    <Textarea
      name="headOfficeAddress"
      value={formData.headOfficeAddress}
      onChange={handleChange}
      rows={4}
    />
  </div>

  <div className="space-y-2">
    <Label>Branch Office Address</Label>
    <Textarea
      name="branchOfficeAddress"
      value={formData.branchOfficeAddress}
      onChange={handleChange}
      rows={4}
    />
  </div>

</div>
            </div>

            {/* Phone & WhatsApp */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>Phone</Label>
                <Input
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="+91 1234567890"
                />
              </div>
              <div className="space-y-2">
                <Label>WhatsApp</Label>
                <Input
                  name="whatsapp"
                  value={formData.whatsapp}
                  onChange={handleChange}
                  placeholder="+91 1234567890"
                />
              </div>
            </div>

            {/* Email */}
            <div className="space-y-2">
              <Label>Email</Label>
              <Input
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            {/* Business Hours */}
            <div className="space-y-2">
              <Label>Business Hours</Label>
              <Input
                name="businessHours"
                value={formData.businessHours}
                onChange={handleChange}
              />
            </div>

            {/* Social URLs */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>Facebook URL</Label>
                <Input
                  name="facebook"
                  value={formData.facebook}
                  onChange={handleChange}
                />
              </div>
              <div className="space-y-2">
                <Label>Instagram URL</Label>
                <Input
                  name="instagram"
                  value={formData.instagram}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Map Embed URL */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

  <div className="space-y-2">
    <Label>Head Office Map Embed URL</Label>
    <Textarea
      name="headOfficeMap"
      value={formData.headOfficeMap}
      onChange={handleChange}
      rows={3}
    />
  </div>

  <div className="space-y-2">
    <Label>Branch Office Map Embed URL</Label>
    <Textarea
      name="branchOfficeMap"
      value={formData.branchOfficeMap}
      onChange={handleChange}
      rows={3}
    />
  </div>

</div>

            {/* Save Button */}
            <Button
              onClick={handleSaveClick}
              disabled={saving}
              className="btn-primary w-full py-3 text-lg"
            >
              {saving ? "Saving..." : "Save Changes"}
            </Button>
          </CardContent>
        </Card>

        {/* Confirmation Modal */}
        {/* Confirmation Modal */}
        {showConfirm && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 px-4">
            <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full text-center animate-scaleUp">
              <p className="text-brand-dark font-bold text-lg mb-4">
                Are you sure you want to save the changes?
              </p>
              <div className="flex justify-center gap-4">
                <Button onClick={confirmSave} className="btn-primary px-6 py-2">
                  Yes
                </Button>
                <Button
                  onClick={() => setShowConfirm(false)}
                  className="bg-gray-300 text-brand-dark px-6 py-2"
                >
                  No
                </Button>
              </div>
            </div>
          </div>
        )}

        {/* Success Modal */}
        {showSuccess && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 px-4">
            <div className="bg-white p-6 rounded-lg shadow-lg text-center animate-scaleUp max-w-sm w-full">
              <p className="text-green-600 font-bold text-lg">
                Saved successfully ✅
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactSettings;
